import { TFlatBlock } from './blocksToFlatDocument';

export default function applyBlockDepthDelta(block: TFlatBlock, delta: number) {
  return { ...block, depth: block.depth + delta };
}
